import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { PriceLine } from './PriceLine';
import { PriceDivider } from './PriceDivider';
import { breakpoints } from '../../constants';
import { getPricingDetails } from '../../utils';
import { IAddOn, IGlassesPackage } from '../../types';

interface IProps {
    className?: string;
    selectedPackage: IGlassesPackage;
    selectedAddOns?: IAddOn[];
}

const BasePricingOverview = ({
    className,
    selectedPackage,
    selectedAddOns,
}: IProps) => {
    const { t } = useTranslation();
    const pricingDetails = getPricingDetails(selectedPackage, selectedAddOns);

    if (!pricingDetails) return null;

    const { framePrice, glassesPrice, total } = pricingDetails;

    const glassesType = selectedPackage.multifocal
        ? t('multifocal')
        : t('single');

    return (
        <div className={className}>
            <h3>{t('overview')}</h3>
            <PriceDivider />
            <PriceLine item={t('frame')} price={framePrice} />
            <PriceLine
                item={glassesType}
                price={glassesPrice}
                starAmount={selectedPackage.strength}
            />
            {selectedAddOns &&
                selectedAddOns.map((selectedAddOn) => {
                    const substring = '- niet combineerbaar';

                    const addOnName = selectedAddOn.name.includes(substring)
                        ? selectedAddOn.name.replace(substring, '')
                        : selectedAddOn.name;

                    return (
                        <PriceLine
                            item={addOnName}
                            key={selectedAddOn.id}
                            price={selectedAddOn.priceInt}
                        />
                    );
                })}
            <PriceDivider />
            <PriceLine bold isTotal item={t('youPay')} price={total} />
        </div>
    );
};

export const PricingOverview = styled(BasePricingOverview)`
    display: flex;
    flex-direction: column;
    padding: 30px;

    @media (${breakpoints.mediumMin}) {
        flex: 0 0 55%;
    }

    h3 {
        font-size: 20px;
        margin-bottom: 15px;
    }
`;
